import * as Sentry from '@sentry/react'
import { Route, Routes } from 'react-router-dom'

import { usePrivateRoutes } from '@/hooks/use-private-routes'
import EditAccount from '@/pages/edit-account'
import EditName from '@/pages/edit-account/edit-name'
import Login from '@/pages/login'
import PasswordRecovery from '@/pages/password-recovery'
import PasswordReset from '@/pages/password-reset'
import Signup from '@/pages/signup'
import { UserConfirm } from '@/pages/user-confirm'

import { CompaniesRoute } from './components/companies-route'
import { Container } from './components/container'
import { NotFoundRoute } from './components/not-found-route'
import { PublicRoute } from './components/public-route'
import { UserRoute } from './components/user-route'
import { routes } from './config'
import { useStyles } from './styles'

const publicRoutes = [
  { path: routes.Login(), Component: Login },
  { path: routes.PasswordRecovery(), Component: PasswordRecovery },
  { path: routes.PasswordReset(), Component: PasswordReset },
  { path: routes.Signup(), Component: Signup },
  { path: routes.UserConfirm(), Component: UserConfirm },
]

const userRoutes = [
  { path: routes.EditAccount(), Component: EditAccount },
  { path: routes.EditName(), Component: EditName },
]

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)

export default function AppRoutes() {
  const classes = useStyles()
  const companiesRoutes = usePrivateRoutes() //TODO: change to companies routes

  return (
    <div className={classes.root}>
      <Container>
        <SentryRoutes>
          {publicRoutes.map(({ Component, path }) => (
            <Route key={path} path={path} element={<PublicRoute />}>
              <Route path={path} element={<Component />} />
            </Route>
          ))}
          {userRoutes.map(({ path, Component }) => (
            <Route key={path} path={path} element={<UserRoute />}>
              <Route path={path} element={<Component />} />
            </Route>
          ))}
          <Route element={<CompaniesRoute />}>
            {companiesRoutes?.map((route, index) =>
              'Wrapper' in route ? (
                <Route key={index} element={<route.Wrapper />}>
                  {route.routes.map(({ Component, path }) => (
                    <Route key={path} path={path} element={<Component />} />
                  ))}
                </Route>
              ) : (
                <Route
                  key={route.path}
                  path={route.path}
                  element={<route.Component />}
                />
              ),
            )}
          </Route>
          <Route path='/*' element={<NotFoundRoute />} />
        </SentryRoutes>
      </Container>
    </div>
  )
}
